var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal",
    { attrs: { open: _vm.open } },
    [
      _c("template", { slot: "content" }, [
        _c(
          "div",
          { staticClass: "emd-container _highlight_header _footer_end" },
          [
            _c(
              "div",
              { staticClass: "emd-container__header" },
              [
                _c("jade-text", { attrs: { variant: "heading-xsmall" } }, [
                  _vm._v(_vm._s(_vm.$t("title"))),
                ]),
                _c("jade-icon-button", {
                  attrs: {
                    icon: "close",
                    size: "small",
                    variant: "neutral-ghost",
                  },
                  on: { click: _vm.handleCloseModal },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "emd-container__content !p-0" },
              [
                _c("jade-list-item", {
                  attrs: { label: _vm.$t("customerName"), trailing: _vm.name },
                }),
                _c("jade-list-item", {
                  attrs: {
                    label: _vm.$t("customerEmail"),
                    trailing: _vm.email,
                  },
                }),
                _c("jade-list-item", {
                  attrs: {
                    label: _vm.$t("confirmedValue"),
                    trailing: _vm.value,
                  },
                }),
                _c("jade-list-item", {
                  attrs: { label: _vm.$t("transaction"), trailing: _vm.value },
                }),
              ],
              1
            ),
            _c("jade-divider"),
            _c(
              "div",
              { staticClass: "emd-container__footer gap-2" },
              [
                _c(
                  "jade-button",
                  {
                    attrs: { variant: "neutral-subtle", size: "medium" },
                    on: { click: _vm.handleCloseModal },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("close")) + " ")]
                ),
                _c(
                  "jade-button",
                  {
                    attrs: { variant: "primary-solid", size: "medium" },
                    on: { click: _vm.handleConfirm },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("confirm")) + " ")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }